<template>
    <div class="content-section active" id="sound-appointment">
        <div class="admin-header">
            <div>
                <h1 class="admin-title">音疗产品预约管理</h1>
                <p>管理用户提交的音疗产品体验预约申请</p>
            </div>
            <div class="admin-actions">
                <button class="admin-btn secondary" @click="soundOutRecord">
                    <i class="fas fa-file-export"></i> 导出数据
                </button>
                <button class="admin-btn" @click="soundAddRecord">
                    <i class="fas fa-plus"></i> 添加记录
                </button>
            </div>
        </div>

        <!-- 数据表格 -->
        <div class="data-table-container">
            <div class="table-controls">
                <div class="search-box">
                    <i class="fas fa-search"></i>
                    <input type="text"
                           id="sound-search-input"
                           @input="handleSearch"
                           placeholder="搜索姓名、公司或联系方式..."
                           v-model="searchText">
                </div>
                <div class="filters">
                    <select class="filter-select" v-model="filters.status">
                        <option value="all">所有状态</option>
                        <option value="create">待处理</option>
                        <option value="contacted">已联系</option>
                        <option value="rejected">已拒绝</option>
                    </select>
                    <select class="filter-select" v-model="filters.interest">
                        <option value="all">所有场景</option>
                        <option value="company">企业健康</option>
                        <option value="medical">医疗辅助</option>
                        <option value="hotel">高端酒店</option>
                        <option value="personal">个人家庭</option>
                        <option value="other">其他场景</option>
                    </select>
                    <select class="filter-select" v-model="filters.date">
                        <option value="30">最近30天</option>
                        <option value="7">最近7天</option>
                        <option value="1">今日</option>
                    </select>
                </div>
            </div>

            <table class="data-table">
                <thead>
                    <tr>
                        <th>联系人</th>
                        <th>公司/机构</th>
                        <th>联系方式</th>
                        <th>预约场景</th>
                        <th>预约时间</th>
                        <th>状态</th>
                        <th>操作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in filteredAppointments"
                        :key="item.id"
                        :data-id="item.id"
                        :data-scene="item.interest"
                        :data-status="item.state"
                        :data-date="item.date">
                        <td>
                            <div class="user-info">
                                <div class="user-avatar">{{ item.name.charAt(0) }}</div>
                                <div>
                                    <div class="user-name">{{ item.name }}</div>
                                </div>
                            </div>
                        </td>
                        <td>{{ item.organization }}</td>
                        <td>
                            <div class="connect-info">{{ item.phone }}</div>
                            <div class="connect-info">{{ item.email }}</div>
                        </td>
                        <td>{{ getSceneText(item.interest) }}</td>
                        <td class="connect-info">{{ item.submit_time }}</td>
                        <td>
                            <span :class="['status-badge', item.state]">
                                {{ getStatusText(item.state) }}
                            </span>
                        </td>
                        <td>
                            <button class="action-btn view-btn" @click="viewDetail(item)">
                                <i class="fas fa-eye"></i> 查看
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- 分页 -->
            <div class="pagination">
                <button class="pagination-btn"
                        :disabled="currentPage === 1"
                        @click="prevPage">
                    <i class="fas fa-chevron-left"></i>
                </button>
                <button v-for="page in totalPages"
                        :key="page"
                        class="pagination-btn"
                        :class="{ active: currentPage === page }"
                        @click="goToPage(page)">
                    {{ page }}
                </button>
                <button class="pagination-btn"
                        :disabled="currentPage === totalPages"
                        @click="nextPage">
                    <i class="fas fa-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>

    
import { exportToCSV } from '../../../../csvExport.js';
import axios from 'axios';
    import { EventBus } from '@/eventBus.js';

export default {
        name: 'SoundAppointment',

  data() {
      return {
          timeout_fd:null,
      searchText: null,
      filters: {
        status: 'all',
        interest: 'all',
        date: '30'
      },
      currentPage: 1,
      pageSize: 10,
      totalItems: 25,
      appointments: [
        {
          id: 's1',
          name: '王经理',
          organization: '科技发展公司',
          
          phone: '138****8888',
          email: 'wang@tech.com',
              interest: 'company',
          submit_time: '2025-06-22 10:30',
          state: 'confirmed',
          date: '2025-06-22'
        },
        {
          id: 's2',
          name: '李总监',
          organization: '五星级酒店',
          phone: '139****9999',
          email: 'li@hotel.com',
          interest: 'hotel',
          submit_time: '2025-06-21 14:00',
          state: 'scheduled',
          date: '2025-06-21'
        },
        {
          id: 's3',
          name: '张医生',
          organization: '人民医院',
          phone: '137****7777',
          email: 'zhang@hospital.com',
          interest: 'medical',
          submit_time: '2025-06-20 15:30',
          state: 'confirmed',
          date: '2025-06-20'
        },
        {
          id: 's4',
          name: '陈女士',
          organization: '',
          phone: '136****6666',
          email: 'chen@personal.com',
          interest: 'home',
          submit_time: '2025-06-19 09:00',
          state: 'canceled',
          date: '2025-06-19'
        }
      ]
    }
        },
        mounted() {
            EventBus.$on('freshSoundList', () => {
                this.getSoundList();
            });
        },
        beforeDestroy() {
            EventBus.$off('freshSoundList');
        },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.pageSize);
    },
    filteredAppointments() {
      let filtered = this.appointments;
      
      // 搜索过滤
      if (this.searchText) {
        const search = this.searchText.toLowerCase();
        filtered = filtered.filter(item => 
          item.name.toLowerCase().includes(search) ||
          item.organization.toLowerCase().includes(search) ||
          item.phone.includes(search) ||
          item.email.toLowerCase().includes(search)
        );
      }
      // 状态过滤
      if (this.filters.status !== 'all') {
        filtered = filtered.filter(item => item.status === this.filters.status);
      }
      // 场景过滤
      if (!this.filters.interest.includes("all")) {
          filtered = filtered.filter(item => item.interest.includes(this.filters.interest));
      }
      // 时间过滤
        if (this.filters.date !== '30') {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
        
            filtered = filtered.filter(item => {
              const itemDate = new Date(item.submit_time);
          
              if (this.filters.date === '1') { // Today
                return itemDate.toDateString() === today.toDateString();
              } else if (this.filters.date === '7') { // Last 7 days
                const sevenDaysAgo = new Date(today);
                sevenDaysAgo.setDate(today.getDate() - 6); 
                return itemDate >= sevenDaysAgo && itemDate <= today;
              }
              return true;
            });
        }
      return filtered;
    }
  },

    created() {
        this.resetParam();
        this.getSoundList();
    },
methods: {
    resetParam() {
        this.appointments = [];
        this.searchText= null;
        this.filters= {
            status: 'all',
            interest: 'all',
            date: '30'
        };
        this.currentPage = 1;
        this.totalItems = 0;
    },
    handleSearch() {
        clearTimeout(this.timeout_fd);
        this.timeout_fd = setTimeout(() => {
            if (this.searchText.length > 0) {
                this.getSearchList();
            } else {
                this.getSoundList();
            }
        }, 1000);
    },
    async getSoundList() {
        const isInExpired = await this.$store.dispatch('isInExpired');
        if (!isInExpired) {
            this.$message({
                message: "登录已过期，请重新登录",
                type: "error",
            });
            return;
        }
        const token = localStorage.getItem('token');
        try {
            const payload = {
                resvType:"sound",
                curpage: this.currentPage,
            };
            const response = await axios.post('/api/reservation/list', payload, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.status !== 200) {
                this.$message({
                    message: "网络异常，请稍后尝试",
                    type: "error",
                });
                console.error(response.status);
                return;
            }
            if (response.data.code !== "00") {
                this.$message({
                    message: response.data.message,
                    type: "error",
                });
                return;
            }
            console.log(response.data.infos);
            this.appointments = response.data.infos;
            this.totalItems = response.data.total;
            console.log(this.appointments);
            
        } catch (error) {
            console.error(' failed:', error);
            this.$message({
                message: "网络异常，请稍后尝试",
                type: "error",
            });
        }
    },
    async getSearchList() {
        const isInExpired = await this.$store.dispatch('isInExpired');
        if (!isInExpired) {
            this.$message({
                message: "登录已过期，请重新登录",
                type: "error",
            });
            return;
        }
        const token = localStorage.getItem('token');
        try {
            const payload = {
                resvType: "sound",
                curpage: this.currentPage,
                search: this.searchText,
            };
            const response = await axios.post('/api/reservation/search', payload, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.status !== 200) {
                this.$message({
                    message: "网络异常，请稍后尝试",
                    type: "error",
                });
                console.error(response.status);
                return;
            }
            if (response.data.code !== "00") {
                this.$message({
                    message: response.data.message,
                    type: "error",
                });
                return;
            }
            console.log(response.data.infos);
            this.appointments = response.data.infos;
            this.totalItems = response.data.total;
        } catch (error) {
            console.error(' failed:', error);
            this.$message({
                message: "网络异常，请稍后尝试",
                type: "error",
            });
        }
    },
    soundOutRecord() {
         const headers = [
             '申请人', '学校/机构', '职位', '联系电话', '电子邮箱',
             '兴趣模块', '申请时间', '状态'
         ];

         const exportData = this.filteredAppointments.map(item => ({
             '申请人': item.name || '',
             '学校/机构': item.organization || '',
             '联系电话': item.phone || '',
             '电子邮箱': item.email || '',
             '兴趣模块': item.interest || '',
             '申请时间': item.submit_time || '',
             '状态': this.getStatusText(item.state) || ''
         }));

         exportToCSV(headers, exportData, '教育预约数据');
    },
    soundAddRecord() {
        this.$emit('show-add-user');
    },
    getStatusText(status) {
        const statusMap = {
            'create': '待处理',
            'contacted': '已联系',
            'rejected': '已拒绝'
        };
        return statusMap[status] || status;
    },
     getSceneText(intest) {
        if (!intest || intest.length == 0) {
            return "";
        }
        const intestList = intest.split(",");
        const sceneMap = {
              'company': '企业健康管理',
              'medical': '医疗辅助',
              'hotel': '高端酒店服务',
              'personal': '家庭使用',
              'other': '其他'
        };

         const translatedList = intestList.map(item => {
             const trimmedItem = item.trim();
             return sceneMap[trimmedItem] || trimmedItem;
         });

         return translatedList.join(", ") || intest;
     },
    viewDetail(item) {
      this.$emit('view-detail', item);
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        if (this.searchText.length > 0) {
            this.getSearchList();
        } else {
            this.getSoundList();
        }
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        if (this.searchText.length > 0) {
            this.getSearchList();
        } else {
            this.getSoundList();
        }
      }
    },
    goToPage(page) {
        if(this.currentPage == page){
            return;
        }
        this.currentPage = page;
        if (this.searchText.length > 0) {
            this.getSearchList();
        } else {
            this.getSoundList();
        }
    }
  }
}
</script>